import { render } from "./WIPSoon.vue?vue&type=template&id=6d3a10c0"
const script = {}

import exportComponent from "C:\\Users\\quinn\\codebase\\personal-site-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__